/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Awaiting_Activation_BodyInputs */



/**
* | output |
* | --- |
* | "Your organization's agreement has started, but it has not been activated yet. Please ask your partner or provider to have it activated." |
*
* @param {Org_Awaiting_Activation_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_awaiting_activation_body = /** @type {((inputs?: Org_Awaiting_Activation_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Awaiting_Activation_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Vereinbarung für Ihre Organisation hat begonnen, sie wurde jedoch noch nicht aktiviert. Bitten Sie Ihren Partner oder Anbieter, die Aktivierung zu veranlassen.")
	return /** @type {LocalizedString} */ ("Your organization's agreement has started, but it has not been activated yet. Please ask your partner or provider to have it activated.")
});